// Canonical engine wire emit for a group/chat participant (#62).
// `chatId` is the phone-form @c.us JID — engines resolve @lid→phone
// at their handler boundary; consumers can trust this is the canonical
// address. The owner of a group is included in the participants array
// (not separated), so `participants.length` == total member count.
//
// The RAW WAWeb-store participant shape (with WaWid id + nested
// contact + admin method-pairs) lives inside the chrome extension;
// the raw baileys participant shape lives inside the baileys pod.
// Both engines project their raw form → BtSlimParticipant at the
// handler emit boundary, so bt-common consumers never see
// engine-internal types (#74 architecture).

import { z } from 'zod';
import { WireJidSchema } from '../../contract/wire-identity';
import { coerceLegacyChatId } from './legacy-id';

const BtSlimParticipantObjectSchema = z.object({
  /** Phone-form @c.us JID. Engines do the @lid→phone resolution at
   *  emit time; consumers can trust this is the canonical address. */
  chatId: WireJidSchema,
  isAdmin: z.boolean().optional(),
  isSuperAdmin: z.boolean().optional(),
  /** Display name; group endpoint resolves via the contact-name cache. */
  name: z.string().nullable().optional(),
});
/** Wrapped in the legacy-id coercion so a pre-rename gateway emitting `id`
 *  per participant still parses — see coerceLegacyChatId. */
export const BtSlimParticipantSchema = z.preprocess(coerceLegacyChatId, BtSlimParticipantObjectSchema);
export type BtSlimParticipant = z.infer<typeof BtSlimParticipantSchema>;
